<template>
  <div class="backtest-bollinger-view">
    <BacktestBollinger />
  </div>
</template>

<script>
import BacktestBollinger from '@/components/quant-trading/BacktestBollinger.vue'

export default {
  name: 'BacktestBollingerView',
  components: { BacktestBollinger }
}
</script>

<style scoped>
.backtest-bollinger-view {
  width: 100%;
  height: 100%;
}
</style>
